module.exports = __webpack_public_path__ + "media/images/background_strip-a472bba572f9cabbbe966aa700f3e27a.png";